import { Button, Form, Input, Select, Spin, Typography } from 'antd'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import routes from '@/constants/routes'
import { Machine, Tank } from '@/types'
import { GetMachineResponse } from '@/types/apis/machines/GetMachineResponse'
import { UpdateMachineRequest } from '@/types/apis/machines/UpdateMachineRequest'

import { SpaceCustom } from '../../style'

export type UpdateMachineFormValue = UpdateMachineRequest

type Props = {
  machineId: number
  updateLoading: boolean
  getMachineResponse?: GetMachineResponse | undefined
  getLoading?: boolean
  machineData?: { name: string; code: string }
  onSubmit: (formValues: UpdateMachineRequest) => void
  onDelete: (id: Machine['id']) => void
  tanks: Tank[] | undefined
}

const { Title } = Typography

const UpdateMachineForm = ({ getMachineResponse, updateLoading, getLoading, onSubmit, tanks }: Props) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [form] = Form.useForm<UpdateMachineRequest>()

  useEffect(() => {
    if (getMachineResponse) {
      const tankIds = getMachineResponse.tanks.map((tank) => tank.id)
      form.setFieldsValue({ ...getMachineResponse, tankIds })
    }
  }, [form, getMachineResponse])

  return (
    <Spin spinning={getLoading}>
      <Form layout="vertical" onFinish={onSubmit} form={form}>
        <Title level={4}>{t('components.pages.machines.update.form.washingInfo')}</Title>
        <Form.Item
          label={t('components.pages.machines.update.form.name')}
          name="name"
          rules={[{ required: true, message: t('components.pages.machines.update.form.requireName') }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label={t('components.pages.machines.update.form.typeName')}
          name="typeName"
          rules={[{ required: true, message: t('components.pages.machines.update.form.requireTypeName') }]}
        >
          <Input />
        </Form.Item>

        <Title level={4}>{t('components.pages.machines.update.form.tankInfo')}</Title>
        <Form.Item label={t('components.pages.machines.update.form.tankNo')} name="tankIds">
          <Select mode="multiple" style={{ border: '1px solid #ccc' }}>
            {tanks?.map((tank) => (
              <Select.Option key={tank.id} value={tank.id}>
                {`${tank.tankNo} ${tank.detergents[0] ? tank.detergents[0].name : ''}`}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item>
          <SpaceCustom>
            <Button onClick={() => navigate(routes.machines.path)}>
              {t('components.pages.machines.update.form.cancel')}
            </Button>
            <Button type="primary" htmlType="submit" loading={updateLoading}>
              {t('components.pages.machines.update.form.update')}
            </Button>
          </SpaceCustom>
        </Form.Item>
      </Form>
    </Spin>
  )
}

UpdateMachineForm.displayName = 'UpdateMachineForm'
export default UpdateMachineForm
